<template>
  <div>
    <q-card class="shadow-10-disabled flat bordered card-login">
      <q-card-section class="text-center">
        <a href="https://www.suez.es/es-es">
          <q-img
            style="height: 97px; max-width: 306px"
            :src="require('@/assets/img/logo-dinapsis.svg')"
          />
        </a>
      </q-card-section>
      <div class="txtInfo">
        Para resetear su contraseña indíquenos su correo electrónico y pulse
        enviar.
      </div>
      <q-card-section>
        <q-input
          data-cy="email-forgot"
          ref="user"
          type="email"
          label="Email"
          outlined
          autofocus
          bottom-slots
          v-model="email"
          @keyup.enter="submit"
          class="q-py-sm q-mb-md fuente"
          :error="v$.email.$error"
          lazy-rules
          :rules="[
            (val) =>
              val == '' ||
              /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val) ||
              'Email no válido',
          ]"
        >
          <template
v-slot:error
            >Por favor escriba el correo electrónico.</template
          >
          <template v-slot:append>
            <q-icon :name="'img:' + require('@/assets/img/user-card.svg')" />
          </template>
        </q-input>
      </q-card-section>
      <q-card-actions>
        <q-btn
          data-cy="submit-forgot"
          @click="validate"
          class="buttonoscuro"
          style="height: 50px"
          >Enviar</q-btn
        >
      </q-card-actions>
    </q-card>
  </div>
</template>

<script>
import { required, email } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import Message from '../../../components/shared/mixins/Message';
import { QImg } from 'quasar';

export default {
  setup: () => ({ v$: useVuelidate() }),
  mixins: [Message],
  name: 'suez-login',
  components: {
    QImg
  },
  data () {
    return {
      isLoading: false,
      isPwd: true,
      email: ''
    };
  },
  validations: {
    email: { required, email }
  },
  methods: {
    async validate () {
      this.v$.$touch();

      if (this.v$.email.$error) {
        this.showError('Debe introducirse correctamente el email');
      } else {
        this.isLoadingUser = true;

        let request = {
          controller: `/User/PasswordChangePetition?email=${this.email}`,
          filter: {},
          Anonymous: true
        };

        this.$store
          .dispatch('PF/getSuit', request)
          .then((response) => {
            // Ok External User
            return this.$router.push({
              name: 'passwordemail',
              params: { email: this.email }
            });
          })
          .catch((err) => {
            // Add Exception if 400 internal user
            if (err.status === 400) { return this.$router.push({ name: 'passwordinternal' }); }

            return this.showError(err.message);
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$verde: #9fce4d;
$azuloscuro: hsl(222, 58%, 13%);
$azuloclaro: #878b97;
$seafoam-blue: #72c7d7;
$seafoam-blue-hover: #5795a1;
$verde-suez: #8dbe2d;

.card-login {
  padding: 16px 70px 85px 70px;
}

.buttonoscuro {
  width: 100%;
  background-color: $seafoam-blue !important;
  border: none;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.5px;
  text-align: center;
  &:hover {
    background-color: $seafoam-blue-hover !important;
    color: #fff;
    font-weight: 500;
  }
}

.buttonclaro {
  width: 100%;
  background-color: $azuloclaro !important;
  border: none;
  color: #fff;
  font-weight: 600;
  letter-spacing: 3px;
  &:hover {
    background-color: $verde !important;
    color: $azuloclaro;
    font-weight: 600;
  }
}

a {
  width: 100%;
  border: none;
  color: $verde-suez;
  font-family: DINPro;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.23px;
  text-align: center;
  &:hover {
    /* color: rgb(71, 70, 70); */
    /* font-weight: 300; */
  }
  &:link {
    text-decoration: none;
  }
}
.txtInfo {
  width: 100%;
  height: 36px;
  font-family: DINPro;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: center;
  color: #1c2d72;
  padding-top: 31px;
  padding-bottom: 40px;
}
.fuente {
  font-family: DINPro;
}
</style>
